import * as React from 'react';
import './YouTravelSearchPageContainer.scss';

export class YouTravelSearchPageContainer extends React.Component<{}, {}> {
    componentDidMount() {
        const script = document.createElement('script');
        const script2 = document.createElement('script');
        script.src = 'https://youtravel.me/widgets/search/v2/app.js';
        script.type = 'text/javascript';
        script2.type = 'text/javascript';
        script.async = true;
        script2.innerHTML = `window.ytSearchWidgetOptions = {
                    color: 'white' || '#fff', //Цвет текста кнопки:string
                    backgroundColor: '#ABC232',// Цвет кнопки и today в календаре:string
                    locale: 'ru', // ru || en: string
                    rootId: 'yt-widget',// ID контейнера для встраивания виджета:string
                    direction: 'row', // row || column: string
                    // Данные для подстановки в URL, выходные данные вида -
                    // click_id='213n4m234kj234hkj2h'&utm_medium='KONSIERGE'
                    queryParams: {
                        click_id: "213n4m234kj234hkj2h",
                        utm_medium: "KONSIERGE",
                    },
                };
                    // Listen for the event.
                    window.addEventListener(
                    'yt.widgets.search.loaded',
                    (e) => {
                    window.mountYtWidget();
                    window.mountYtWidget({
                    rootId: 'yt-widget2'
                });
                },
                    false
                    );`;

        document.body.appendChild(script);
        document.body.appendChild(script2);
    }

    render() {
        return (
            <div className='you_travel_search_container'>
                <h1>
                    Авторские туры&nbsp;—&nbsp;новый формат насыщенных путешествий
                </h1>
                <div id='yt-widget2'/>
                <div className='icons-row'>
                    <div className='icons-row__item'>
                        <div className='icons-row__icon icons-row__icon--lock'/>
                        <div className='icons-row__title'>Безопасная оплата</div>
                        <div className='icons-row__description'>Бронируйте туры через нашу надежную платежную систему
                        </div>
                    </div>
                    <div className='icons-row__item'>
                        <div className='icons-row__icon icons-row__icon--laughing'/>
                        <div className='icons-row__title'>Продуманная спонтанность</div>
                        <div className='icons-row__description'>Маршруты могут адаптироваться под пожелания группы</div>
                    </div>
                    <div className='icons-row__item'>
                        <div className='icons-row__icon icons-row__icon--verified-experts'/>
                        <div className='icons-row__title'>Проверенные тревел-эксперты</div>
                        <div className='icons-row__description'>В нашей базе 10&nbsp;222 гида, которые прошли тщательный
                            отбор
                        </div>
                    </div>
                    <div className='icons-row__item'>
                        <div className='icons-row__icon icons-row__icon--pin-start'/>
                        <div className='icons-row__title'>Гарантированные туры</div>
                        <div className='icons-row__description'>У нас вы найдете более 123&nbsp;658 туров с
                            гарантированным отправлением
                        </div>
                    </div>
                    <div className='icons-row__item'>
                        <div className='icons-row__icon icons-row__icon--verified'/>
                        <div className='icons-row__title'>Небольшие группы</div>
                        <div className='icons-row__description'>Особенная атмосфера в компании единомышленников</div>
                    </div>
                </div>
                <h2>
                    Для получения 5% скидки используйте промокод КОНСЬЕРЖ при оплате тура
                    <br/>
                    (поле «У меня есть промокод»)
                </h2>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/YouTravel/search/YouTravelSearchPageContainer.tsx